import { maxBreakpoints, minBreakpoints } from '@noths/polaris-client-ribbons-design-system';
import { mediaQuery } from '@noths/polaris-client-styles';
import styled, { css } from 'styled-components';

export const DisplayWhenSmall = styled.div`
  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      display: none;
    `,
  )}
`;

export const DisplayWhenMediumAndUp = styled.div`
  ${mediaQuery(
    { max: maxBreakpoints.S },
    css`
      display: none;
    `,
  )}
`;

export const DisplayWhenMediumAndDown = styled.div`
  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      display: none;
    `,
  )}
`;

export const DisplayWhenLargeAndUp = styled.div`
  ${mediaQuery(
    { max: maxBreakpoints.M },
    css`
      display: none;
    `,
  )}
`;
